<div #pageContainer class="w-full">
    <form [formGroup]="searchForm">
        <div class="grid grid-cols-2 gap-2">
            <div class="flex justify-start">
                <div class="w-19 mx-2">
                    <mat-form-field class="w-full">
                        <mat-select formControlName="PageSize">
                            <mat-option [value]="10"> 10 </mat-option>
                            <mat-option [value]="20"> 20 </mat-option>
                            <mat-option [value]="50"> 50 </mat-option>
                            <mat-option [value]="100"> 100 </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <button class="btn btn-outline btn-default dt-download mx-2 group" [matMenuTriggerFor]="downloadMenu">
                    <mat-icon class="text-primary group-hover:text-white"
                        svgIcon="heroicons_solid:arrow-down-tray"></mat-icon>
                </button>
                <mat-menu #downloadMenu="matMenu">
                    <button mat-menu-item (click)="downloadStringsSummaryExcel()">
                        <span>Excel</span>
                    </button>
                </mat-menu>
            </div>
            <div class="flex justify-end">
                <app-single-filter [searchForm]="searchForm" [filterBy]="'String'"
                    class="text-primary w-64"></app-single-filter>

                <button class="btn btn-primary mx-2" (click)="setPage({ offset: 0 })">
                    Search
                </button>
                <button class="btn btn-outline btn-default" (click)="reset()">
                    Reset
                </button>
                <button class="btn btn-outline btn-default mx-2 group" (click)="setPage({ offset: dt.page.offset })">
                    <mat-icon class="text-primary group-hover:text-white"
                        svgIcon="heroicons_solid:arrow-path"></mat-icon>
                </button>
            </div>
        </div>
    </form>

    <div class="grid overflow-x-auto">
        <!-- Header -->
        <div class="table-moc-string-summary-grid z-10 sticky top-0 grid shadow text-md font-semibold text-white bg-primary dark:bg-black dark:bg-opacity-5"
            matSort matSortDisableClear>
            <div class="border py-8 text-center">No</div>

            <div [mat-sort-header]="'fieldLongName'" class="flex justify-center border py-8">
                Field
            </div>

            <div [mat-sort-header]="'platformLongName'" class="flex justify-center border py-8">
                Platform
            </div>

            <div [mat-sort-header]="'wellLongName'" class="flex justify-center border py-8">
                Well
            </div>

            <div [mat-sort-header]="'stringShortName'" class="flex justify-center border py-8">
                Well String
            </div>

            <div [mat-sort-header]="'stringIndicatorShortName'" class="flex justify-center border py-8">
                String Indicator
            </div>

            <div [mat-sort-header]="'title'" class="flex justify-center border py-8">
                Title
            </div>

            <div [mat-sort-header]="'refNo'" class="flex justify-center border py-8">
                Ref No
            </div>

            <div [mat-sort-header]="'extNo'" class="flex justify-center border py-8">
                Extension No
            </div>

            <div [mat-sort-header]="'startDate'" class="flex justify-center border py-8">
                Start Date
            </div>

            <div [mat-sort-header]="'endDate'" class="flex justify-center border py-8">
                End Date
            </div>

            <div [mat-sort-header]="'keyIssues'" class="flex justify-center border py-8">
                Key Issues
            </div>

            <div [mat-sort-header]="'stage'" class="flex justify-center border py-8">
                Stage
            </div>

            <div [mat-sort-header]="'closeDate'" class="flex justify-center border py-8">
                Closed Date
            </div>

            <div [mat-sort-header]="'requestBy'" class="flex justify-center border py-8">
                Requested By
            </div>

            <div [mat-sort-header]="'status'" class="flex justify-center border py-8">
                Status
            </div>

            <div [mat-sort-header]="'approvalStatus'" class="flex justify-center border py-8">
                Approved Status
            </div>
        </div>
        <!-- Rows -->
        <ng-container *ngIf="dt.rows.length; else noRecords">
            <ng-container *ngFor="let row of dt.rows; let i = index; trackBy: trackByFn">
                <div class="table-moc-string-summary-grid grid items-center border-b py-3"
                    [ngClass]="{ 'bg-primary-100': i % 2 }">
                    <!-- No -->
                    <div class="py-4 text-center">
                        {{ startingIndex + i + 1 }}.
                    </div>

                    <!-- Field Long Name -->
                    <div class="flex truncate justify-center">
                        {{ row.fieldLongName }}
                    </div>

                    <!-- Plaform Long Name -->
                    <div class="flex truncate justify-center">
                        {{ row.platformLongName }}
                    </div>

                    <!-- Well Long Name -->
                    <div class="flex truncate justify-center">
                        {{ row.wellLongName }}
                    </div>

                    <!-- Well String Long Name -->
                    <div class="flex truncate justify-center">
                        {{ row.stringShortName || "-" }}
                    </div>

                    <!--  String Indicator -->
                    <div class="flex truncate justify-center">
                        {{ row.stringIndicatorShortName || "-" }}
                    </div>

                    <!-- Title -->
                    <div class="flex truncate justify-center whitespace-normal break-words text-center">
                        {{ row.title }}
                    </div>

                    <!-- ref No -->
                    <div class="flex truncate justify-center">
                        {{ row.refNo }}
                    </div>

                    <!-- extension no  -->
                    <div class="flex truncate justify-center">
                        {{ row.extNo }}
                    </div>

                    <!-- start date -->
                    <div class="flex truncate justify-center">
                        {{ handleFormatDate(row.startDate, false) }}
                    </div>

                    <!-- end date -->
                    <div class="flex truncate justify-center">
                        {{ handleFormatDate(row.endDate, false) }}
                    </div>

                    <!-- key issue -->
                    <div class="flex truncate justify-center whitespace-normal break-words text-center">
                        {{ row.keyIssues || "-" }}
                    </div>

                    <!-- stage -->
                    <div class="flex truncate justify-center whitespace-normal break-words text-center">
                        {{ row.stage }}
                    </div>

                    <!-- closed date -->
                    <div class="flex truncate justify-center">
                        {{ handleFormatDate(row.closeDate, false) || "-" }}
                    </div>

                    <!-- requested by -->
                    <div class="flex truncate justify-center">
                        {{ row.requestBy }}
                    </div>

                    <!-- status -->
                    <div class="flex truncate justify-center mx-2" [ngClass]="{
                            idleBadge: row.status == mocStatus.ACTIVE,
                            successBadge:
                                row.status == mocStatus.CLOSED ||
                                row.status == mocStatus.CLOSEOUT,
                            failedBadge:
                                row.status == mocStatus.REJECTED ||
                                row.status == mocStatus.CANCELLED,
                            warningBadge:
                                row.status == mocStatus.APPROVALPROCESS ||
                                row.status ==
                                    mocStatus.EXTENSIONAPPROVALPROCESS,
                        }">
                        {{ row.status }}
                    </div>

                    <!-- approval status -->
                    <div class="flex truncate justify-center mx-2" [ngClass]="{
                            successBadge:
                                row.approvalStatus ==
                                mocApprovalStatus.APPROVED,
                            failedBadge:
                                row.approvalStatus ==
                                mocApprovalStatus.REJECTED,
                            warningBadge:
                                row.approvalStatus == mocApprovalStatus.PENDING,
                        }">
                        {{ row.approvalStatus }}
                    </div>
                </div>
            </ng-container>
        </ng-container>

        <ng-template #noRecords>
            <div class="p-8 sm:p-16 text-2xl sm:text-2xl font-semibold tracking-tight text-center">
                There are no records registered!
            </div>
        </ng-template>
    </div>

    <div
        class="flex justify-between inset-x-0 bottom-0 border-b border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent">
        <div class="content-center px-3">
            {{ dt.page.totalRecords || 0 }}
            {{ dt.page.totalRecords <= 1 ? "total" : "totals" }} </div>

                <mat-paginator class="bg-gray-50" [ngClass]="{ 'pointer-events-none': isLoading }"
                    [length]="dt.page?.totalRecords" [pageIndex]="dt.page.offset" [pageSize]="dt.page.size"
                    [hidePageSize]="true" [showFirstLastButtons]="true">
                </mat-paginator>
        </div>
    </div>